import { render, staticRenderFns } from "./gym.vue?vue&type=template&id=49ff356f&scoped=true"
import script from "./gym.vue?vue&type=script&lang=js"
export * from "./gym.vue?vue&type=script&lang=js"
import style0 from "./gym.vue?vue&type=style&index=0&id=49ff356f&prod&lang=css"
import style1 from "./gym.vue?vue&type=style&index=1&id=49ff356f&prod&scoped=true&lang=css"
import style2 from "./gym.vue?vue&type=style&index=2&id=49ff356f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ff356f",
  null
  
)

export default component.exports